import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orientation", "pane"]

  updateOrientation() {
    this.paneTargets.forEach((target) => {
      target.dataset.cardCanvasOrientationValue = this.orientationTarget.value
    })
  }
}
